import React from 'react';
import { createRoot } from 'react-dom/client';
import ILPPageApp from './components/ilp-page-app';


const entryDiv = document.getElementById('ilp-page-app');

if (entryDiv) {
    const root = createRoot(entryDiv);
    const { epiProps, organizations, userFullName, selectedOrganization, plans, customerKey, nfToken } = (window as any).ilpPageBootstrap;

    root.render(
        <ILPPageApp
            epiProps={epiProps}
            organizations={organizations}
            userFullName={userFullName}
            selectedOrganization={selectedOrganization}
            plans={plans}
            customerKey={customerKey}
            nfToken={nfToken}
        />
    )
}